/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { DatePicker, Button, Upload, Icon, Input, message, Tabs } from 'antd'
import moment from 'moment'

import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { strCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
} from 'core/utils'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'

import { DatePickerContext, SpinContext, ErrorContext } from 'context'
import {
  getEnvConfig,
  getPermitActions,
  getApiTargetInfo,
  ExportComponent,
} from 'core'
import * as ScreenPermissions from 'core/EventActions'
import { CriteriaRow, Title, FullHeightSizer, Content } from 'core/screen-util'
import { getBSGFImport, getAuthorization, getCredentials } from 'api/pgads.js'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

// eslint-disable-next-line no-unused-vars
const Bsgf10minImportHeaders = [
  dateTimeCol({
    ident: 'pctimestamp',
    display: 'Pctimestamp',
    isKey: true,
    width: 200,
  }),
  strCol({ ident: 'a1AlarmCode', display: 'A1 Alarm Code', isFiltered: true }),
  strCol({ ident: 'a3AlarmCode', display: 'A3 Alarm Code', isFiltered: true }),
  strCol({ ident: 'a4AlarmCode', display: 'A4 Alarm Code', isFiltered: true }),
  strCol({ ident: 'a5AlarmCode', display: 'A5 Alarm Code', isFiltered: true }),
  strCol({ ident: 'a6AlarmCode', display: 'A6 Alarm Code', isFiltered: true }),
  strCol({ ident: 'a7AlarmCode', display: 'A7 Alarm Code', isFiltered: true }),
  strCol({ ident: 'a8AlarmCode', display: 'A8 Alarm Code', isFiltered: true }),
  strCol({ ident: 'a9AlarmCode', display: 'A9 Alarm Code', isFiltered: true }),
  strCol({
    ident: 'a10AlarmCode',
    display: 'A10 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a11AlarmCode',
    display: 'A11 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a12AlarmCode',
    display: 'A12 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a13AlarmCode',
    display: 'A13 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a14AlarmCode',
    display: 'A14 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a15AlarmCode',
    display: 'A15 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a16AlarmCode',
    display: 'A16 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a20AlarmCode',
    display: 'A20 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a21AlarmCode',
    display: 'A21 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a22AlarmCode',
    display: 'A22 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a23AlarmCode',
    display: 'A23 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a24AlarmCode',
    display: 'A24 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a25AlarmCode',
    display: 'A25 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a26AlarmCode',
    display: 'A26 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a27AlarmCode',
    display: 'A27 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a28AlarmCode',
    display: 'A28 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a29AlarmCode',
    display: 'A29 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a30AlarmCode',
    display: 'A30 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a31AlarmCode',
    display: 'A31 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a32AlarmCode',
    display: 'A32 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a33AlarmCode',
    display: 'A33 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a34AlarmCode',
    display: 'A34 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a35AlarmCode',
    display: 'A35 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a36AlarmCode',
    display: 'A36 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a38AlarmCode',
    display: 'A38 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a39AlarmCode',
    display: 'A39 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a40AlarmCode',
    display: 'A40 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a41AlarmCode',
    display: 'A41 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a42AlarmCode',
    display: 'A42 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a43AlarmCode',
    display: 'A43 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a44AlarmCode',
    display: 'A44 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a45AlarmCode',
    display: 'A45 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'a46AlarmCode',
    display: 'A46 Alarm Code',
    isFiltered: true,
  }),
  strCol({ ident: 'b1AlarmCode', display: 'B1 Alarm Code', isFiltered: true }),
  strCol({ ident: 'b2AlarmCode', display: 'B2 Alarm Code', isFiltered: true }),
  strCol({ ident: 'b3AlarmCode', display: 'B3 Alarm Code', isFiltered: true }),
  strCol({ ident: 'b4AlarmCode', display: 'B4 Alarm Code', isFiltered: true }),
  strCol({ ident: 'b5AlarmCode', display: 'B5 Alarm Code', isFiltered: true }),
  strCol({ ident: 'b8AlarmCode', display: 'B8 Alarm Code', isFiltered: true }),
  strCol({ ident: 'b9AlarmCode', display: 'B9 Alarm Code', isFiltered: true }),
  strCol({
    ident: 'b10AlarmCode',
    display: 'B10 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b11AlarmCode',
    display: 'B11 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b12AlarmCode',
    display: 'B12 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b14AlarmCode',
    display: 'B14 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b15AlarmCode',
    display: 'B15 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b16AlarmCode',
    display: 'B16 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b17AlarmCode',
    display: 'B17 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b18AlarmCode',
    display: 'B18 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b19AlarmCode',
    display: 'B19 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b20AlarmCode',
    display: 'B20 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b21AlarmCode',
    display: 'B21 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b22AlarmCode',
    display: 'B22 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b23AlarmCode',
    display: 'B23 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b24AlarmCode',
    display: 'B24 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b25AlarmCode',
    display: 'B25 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b26AlarmCode',
    display: 'B26 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b27AlarmCode',
    display: 'B27 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b28AlarmCode',
    display: 'B28 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b29AlarmCode',
    display: 'B29 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b31AlarmCode',
    display: 'B31 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b32AlarmCode',
    display: 'B32 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b33AlarmCode',
    display: 'B33 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b34AlarmCode',
    display: 'B34 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b35AlarmCode',
    display: 'B35 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b36AlarmCode',
    display: 'B36 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b37AlarmCode',
    display: 'B37 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b38AlarmCode',
    display: 'B38 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'b39AlarmCode',
    display: 'B39 Alarm Code',
    isFiltered: true,
  }),
  strCol({ ident: 'c2AlarmCode', display: 'C2 Alarm Code', isFiltered: true }),
  strCol({
    ident: 'c17AlarmCode',
    display: 'C17 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'c37AlarmCode',
    display: 'C37 Alarm Code',
    isFiltered: true,
  }),
  strCol({ ident: 'd6AlarmCode', display: 'D6 Alarm Code', isFiltered: true }),
  strCol({ ident: 'd7AlarmCode', display: 'D7 Alarm Code', isFiltered: true }),
  strCol({
    ident: 'd13AlarmCode',
    display: 'D13 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'd30AlarmCode',
    display: 'D30 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'd41AlarmCode',
    display: 'D41 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'd42AlarmCode',
    display: 'D42 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'd43AlarmCode',
    display: 'D43 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'd44AlarmCode',
    display: 'D44 Alarm Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'f40AlarmCode',
    display: 'F40 Alarm Code',
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const BSGFImport = ({ apiTargetInfo, envConfig, actionPermits }) => {
  const [mwImportData, setMwImportData] = useState({})
  const [fuzzyFilter, setFuzzyFilter] = useState(null)
  const [showMessages, setShowMessages] = useState(false)
  const [messages, setMessages] = useState([])
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const fetchMwImportData = () => {
    setSpinning(true)
    getBSGFImport(apiTargetInfo)({
      date: moment(selectedDate).format('YYYY-MM-DD'),
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
    }).fork(setError, data => {
      setSpinning(false)
      setMwImportData(data)
    })
  }

  const fileProps = importType => ({
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/interface-data/import-parser`,
    method: 'POST',
    data: { importType },
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  })

  const { authGodMode } = envConfig
  const GridData = useRef()
  const GridContractData = useRef()
  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow style={{ gridColumnGap: '5px' }}>
        <Title
          css={{
            marginRight: '15px',
            marginBottom: '5px',
            minWidth: '100px',
          }}
        >
          BSGF Import
        </Title>

        <DatePicker.MonthPicker
          allowClear={false}
          format="MMMM-YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d.startOf('month'))
          }}
          style={{ marginLeft: '10px' }}
        />

        <Button
          loading={spinning}
          onClick={fetchMwImportData}
          css={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>

        <Upload
          {...fileProps('BSEG_10MIN')}
          onChange={data => {
            if (
              data.file.response &&
              data.file.response.restfulStatus &&
              data.file.response.restfulStatus === 'FAILURE'
            ) {
              // setShowMessages(true)
              // setMessages([data.file.response])
              setError(data.file.response)
            } else if (data.file.response && data.file.response.length === 0) {
              //  if (data.file.response) {
              message.success('File imported successfully')
              // }
            } else if (data.file.response && data.file.response.length > 0) {
              setShowMessages(true)
              setMessages(data.file.response)
              //  if (data.file.response) {
              // message.success('File imported successfully')
              // }
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button
            disabled={
              !hasAccesPermits({
                authGodMode,
                actionPermits,
                eventActions: [ScreenPermissions.BSGF_IMPORT_ADMIN],
                matchAny: true,
              })
            }
          >
            <Icon type="upload" /> Import BSGF 10 MIN
          </Button>
        </Upload>

        <Upload
          {...fileProps('BSEG_CONTENT')}
          onChange={data => {
            if (
              data.file.response &&
              data.file.response.restfulStatus &&
              data.file.response.restfulStatus === 'FAILURE'
            ) {
              // setShowMessages(true)
              // setMessages([data.file.response])
              setError(data.file.response)
            } else if (data.file.response && data.file.response.length === 0) {
              //  if (data.file.response) {
              message.success('File imported successfully')
              // }
            } else if (data.file.response && data.file.response.length > 0) {
              setShowMessages(true)
              setMessages(data.file.response)
              //  if (data.file.response) {
              // message.success('File imported successfully')
              // }
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button
            disabled={
              !hasAccesPermits({
                authGodMode,
                actionPermits,
                eventActions: [ScreenPermissions.BSGF_IMPORT_ADMIN],
                matchAny: true,
              })
            }
          >
            <Icon type="upload" /> Import BSGF Contact
          </Button>
        </Upload>

        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          css={{ marginRight: '20px', flex: '0 0 150px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <ExportComponent
          title="BSGF 10 Min"
          getData={
            exportDataComponent
              ? _ =>
                  exportDataComponent(
                    GridData,
                    mwImportData.bsgf10minImports || [],
                    fuzzyFilter
                  )
              : undefined
          }
          data={mwImportData.bsgf10minImports || []}
          headers={Bsgf10minImportHeaders}
          fileName={`BSGF 10 Min Import-${selectedDate.format(
            'YYYY-MM-DD HH-mm-ss'
          )}`}
          btnStyle={{ marginRight: '10px' }}
          disabled={(mwImportData.bsgf10minImports || []).length <= 0}
        />

        <ExportComponent
          title="BSGF Contact"
          getData={
            exportDataComponent
              ? _ =>
                  exportDataComponent(
                    GridContractData,
                    mwImportData.bsgfContractImports || [],
                    fuzzyFilter
                  )
              : undefined
          }
          data={mwImportData.bsgfContractImports || []}
          headers={BsgfContactImportHeaders}
          fileName={`BSGF Contact Import-${selectedDate.format(
            'YYYY-MM-DD HH-mm-ss'
          )}`}
          btnStyle={{ marginRight: '10px' }}
          disabled={(mwImportData.bsgfContractImports || []).length <= 0}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={230}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Tabs>
              <Tabs.TabPane tab="BSGF 10 Min" title="BSGF 10 Min" key="10min">
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    height: height - 100 + 'px',
                    width: width - 150 + 'px',
                  }}
                >
                  <Grid
                    ref={GridData}
                    data={mwImportData.bsgf10minImports || []}
                    headers={Bsgf10minImportHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 150,
                      headerRowHeight: 30,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    initialSortOptions={[
                      dateTimeCol({
                        ident: 'pctimestamp',
                        display: 'Pctimestamp',
                        sortOrder: 'asc',
                      }),
                    ]}
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane
                tab="BSGF Contact"
                title="BSGF Contact"
                key="Contact"
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    height: height - 100 + 'px',
                    width: width - 150 + 'px',
                  }}
                >
                  <Grid
                    ref={GridContractData}
                    data={mwImportData.bsgfContractImports || []}
                    headers={BsgfContactImportHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: true,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 150,
                      headerRowHeight: 30,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    initialSortOptions={[
                      dateTimeCol({
                        ident: 'pctimestamp',
                        display: 'Pctimestamp',
                        sortOrder: 'asc',
                      }),
                    ]}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
      {showMessages && (
        <JcTmpErrorDialog
          errors={messages}
          visible={showMessages}
          closeErrorPrompt={_ => setShowMessages(false)}
          title="Error/Warning"
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(BSGFImport)

const BsgfContactImportHeaders = [
  dateTimeCol({
    ident: 'pctimestamp',
    display: 'Pctimestamp',
    isKey: true,
    width: 200,
  }),
  strCol({ ident: 'a1GenStatus', display: 'A1 Gen Status', isFiltered: true }),
  strCol({ ident: 'a3GenStatus', display: 'A3 Gen Status', isFiltered: true }),
  strCol({ ident: 'a4GenStatus', display: 'A4 Gen Status', isFiltered: true }),
  strCol({ ident: 'a5GenStatus', display: 'A5 Gen Status', isFiltered: true }),
  strCol({ ident: 'a6GenStatus', display: 'A6 Gen Status', isFiltered: true }),
  strCol({ ident: 'a7GenStatus', display: 'A7 Gen Status', isFiltered: true }),
  strCol({ ident: 'a8GenStatus', display: 'A8 Gen Status', isFiltered: true }),
  strCol({ ident: 'a9GenStatus', display: 'A9 Gen Status', isFiltered: true }),
  strCol({
    ident: 'a10GenStatus',
    display: 'A10 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a11GenStatus',
    display: 'A11 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a12GenStatus',
    display: 'A12 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a13GenStatus',
    display: 'A13 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a14GenStatus',
    display: 'A14 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a15GenStatus',
    display: 'A15 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a16GenStatus',
    display: 'A16 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a20GenStatus',
    display: 'A20 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a21GenStatus',
    display: 'A21 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a22GenStatus',
    display: 'A22 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a23GenStatus',
    display: 'A23 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a24GenStatus',
    display: 'A24 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a25GenStatus',
    display: 'A25 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a26GenStatus',
    display: 'A26 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a27GenStatus',
    display: 'A27 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a28GenStatus',
    display: 'A28 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a29GenStatus',
    display: 'A29 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a30GenStatus',
    display: 'A30 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a31GenStatus',
    display: 'A31 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a32GenStatus',
    display: 'A32 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a33GenStatus',
    display: 'A33 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a34GenStatus',
    display: 'A34 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a35GenStatus',
    display: 'A35 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a36GenStatus',
    display: 'A36 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a38GenStatus',
    display: 'A38 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a39GenStatus',
    display: 'A39 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a40GenStatus',
    display: 'A40 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a41GenStatus',
    display: 'A41 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a42GenStatus',
    display: 'A42 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a43GenStatus',
    display: 'A43 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a44GenStatus',
    display: 'A44 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a45GenStatus',
    display: 'A45 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'a46GenStatus',
    display: 'A46 Gen Status',
    isFiltered: true,
  }),
  strCol({ ident: 'b1GenStatus', display: 'B1 Gen Status', isFiltered: true }),
  strCol({ ident: 'b2GenStatus', display: 'B2 Gen Status', isFiltered: true }),
  strCol({ ident: 'b3GenStatus', display: 'B3 Gen Status', isFiltered: true }),
  strCol({ ident: 'b4GenStatus', display: 'B4 Gen Status', isFiltered: true }),
  strCol({ ident: 'b5GenStatus', display: 'B5 Gen Status', isFiltered: true }),
  strCol({ ident: 'b8GenStatus', display: 'B8 Gen Status', isFiltered: true }),
  strCol({ ident: 'b9GenStatus', display: 'B9 Gen Status', isFiltered: true }),
  strCol({
    ident: 'b10GenStatus',
    display: 'B10 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b11GenStatus',
    display: 'B11 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b12GenStatus',
    display: 'B12 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b14GenStatus',
    display: 'B14 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b15GenStatus',
    display: 'B15 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b16GenStatus',
    display: 'B16 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b17GenStatus',
    display: 'B17 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b18GenStatus',
    display: 'B18 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b19GenStatus',
    display: 'B19 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b20GenStatus',
    display: 'B20 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b21GenStatus',
    display: 'B21 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b22GenStatus',
    display: 'B22 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b23GenStatus',
    display: 'B23 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b24GenStatus',
    display: 'B24 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b25GenStatus',
    display: 'B25 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b26GenStatus',
    display: 'B26 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b27GenStatus',
    display: 'B27 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b28GenStatus',
    display: 'B28 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b29GenStatus',
    display: 'B29 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b31GenStatus',
    display: 'B31 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b32GenStatus',
    display: 'B32 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b33GenStatus',
    display: 'B33 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b34GenStatus',
    display: 'B34 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b35GenStatus',
    display: 'B35 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b36GenStatus',
    display: 'B36 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b37GenStatus',
    display: 'B37 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b38GenStatus',
    display: 'B38 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'b39GenStatus',
    display: 'B39 Gen Status',
    isFiltered: true,
  }),
  strCol({ ident: 'c2GenStatus', display: 'C2 Gen Status', isFiltered: true }),
  strCol({
    ident: 'c17GenStatus',
    display: 'C17 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'c37GenStatus',
    display: 'C37 Gen Status',
    isFiltered: true,
  }),
  strCol({ ident: 'd6GenStatus', display: 'D6 Gen Status', isFiltered: true }),
  strCol({ ident: 'd7GenStatus', display: 'D7 Gen Status', isFiltered: true }),
  strCol({
    ident: 'd13GenStatus',
    display: 'D13 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'd30GenStatus',
    display: 'D30 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'd41GenStatus',
    display: 'D41 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'd42GenStatus',
    display: 'D42 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'd43GenStatus',
    display: 'D43 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'd44GenStatus',
    display: 'D44 Gen Status',
    isFiltered: true,
  }),
  strCol({
    ident: 'f40GenStatus',
    display: 'F40 Gen Status',
    isFiltered: true,
  }),
]
